import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-static-page-loader',
  templateUrl: './static-page-loader.component.html',
  styleUrls: ['./static-page-loader.component.scss']
})
export class StaticPageLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
